import extend from '@/utils/vuex-extend';
import {dialog} from '@/vuex-extend';
import {addexp, getPolicy} from '@/api/sms/arrival-order';
import {wait} from '@/utils/wait';
import {Message} from 'element-ui';
import OSS from "ali-oss";
import printSku from "@/utils/printTemp/skuPrintTemplate";

export default extend(dialog, {
	namespaced: true,
	state: {
		recId: 0,
		id: 0,
		form: {},
		alibabaOrderCode: '',
		adminId: 0,
		goodsInfo: ''
	},
	actions: {
		async afterOpenDialog({dispatch, commit, state}, payload) {
		},
		async confirm({dispatch, commit, state}, payload) {
			const {recId, id, form} = state;
			await wait(dispatch, `sms.arrival-order.addexp.confirm`, async function () {
				const response = await addexp(recId, {
					realInStockSkuId: id,
					...form
				});
				if (response.data.reasonMessage) {
					Message.success('添加成功');
					if(form.expReason !== 4){
						let printList = [];
						for (let i = 0; i < form.expNum; i++) {
							printList.push(payload.product);
						}
						printSku(printList, '', {
							adminId: payload.adminId,
							userId: payload.userId,
							alibabaOrderCode: payload.alibabaOrderCode,
							type: 1,
							reasonMessage: response.data.reasonMessage
						})
					}
					dispatch('closeDialog');
					// 重新获取详情
					dispatch('smsArrivalOrderDetail/afterOpenDialog', {}, {root: true})
					// 重新获取列表
					dispatch('smsArrivalOrder/getList', {}, {root: true})
				}
			})
		},
		async upload({dispatch, commit, state}, payload) {
			try {
				const policy = await getPolicy();
				// todo upload to oss
				let percent = 0;
				let client = new OSS({
					region: "<Your region>",
					accessKeyId: policy.accessKeyId,
					accessKeySecret: "<Your AccessKeySecret>",
					bucket: "Your bucket name"
				});
				let result = await client.multipartUpload(policy.dir, payload.file, {
					progress: function (p, checkpoint) {
						payload.onProgress({
							percent: p
						});
						// 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发继续上传。
						tempCheckpoint = checkpoint;
					},
					meta: {year: 2020, people: "test"},
					mime: "image/jpeg"
				});
				payload.onSuccess();
			} catch (error) {
				console.log(error);
				payload.onError();
			}
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/arrival-order/addexp.js